import { render } from "./PurchaseFailModal.vue?vue&type=template&id=18806d30"
import script from "./PurchaseFailModal.vue?vue&type=script&lang=js"
export * from "./PurchaseFailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__